import React from 'react';

function Loading() {
  return (
    <div className="loading">
      <div className="spinner"></div>
      <p>Loading your quotes...</p>
    </div>
  );
}

export default Loading;
